import React from 'react';
import Preloader from '../components/fx/Preloader';
import HeroSection from '../components/home/HeroSection';
import BusinessesSection from '../components/home/BusinessesSection';
import CareersSection from '../components/home/CareersSection';
import BootcampSection from '../components/home/BootcampSection';
import JsonLd from '../components/JsonLd';
import usePageMeta from '../lib/usePageMeta';
import { homeStructuredData } from '../lib/structuredData';
import { PAGE_META } from '../data/pageMeta';

const STRUCTURED_DATA = homeStructuredData({ description: PAGE_META.home.description });

const Home = () => {
  usePageMeta(PAGE_META.home);
  return (
    <main className="bg-paper text-ink">
      <JsonLd data={STRUCTURED_DATA} />
      <Preloader />
      <HeroSection />
      <BusinessesSection />
      <CareersSection />
      <BootcampSection />
    </main>
  );
};

export default Home;
